import _ from "lodash";
import produce from "immer";
import axios from "axios";
import strings from "../../../res/strings";
import { setAppProcessing, setAppSuccess, setAppError } from "../../common";

export const UPLOAD_FILES = "file/UPLOAD_FILES";

export const UPLOAD_FILES_REQUESTED = "file/UPLOAD_FILES_REQUESTED";
export const UPDATE_FILE_UPLOAD_PROGRESS = "file/UPDATE_FILE_UPLOAD_PROGRESS";
export const UPLOAD_FILE_SUCCESS = "file/UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_ERROR = "file/UPLOAD_FILE_ERROR";
export const UPLOAD_FILES_CLEAR_ALL_PROGRESS =
  "file/UPLOAD_FILES_CLEAR_ALL_PROGRESS";

export const DELETE_FILE = "file/DELETE_FILE";
export const RETRIEVE_FILES = "file/RETRIEVE_FILES";

const DELETE_FILE_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};

const RETRIEVE_FILES_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};

export const FilePermissionTypes = {
  PRIVATE: "PRIVATE",
  GROUP: "GROUP",
  PUBLIC: "PUBLIC",
};

export const FileUploadStatus = {
  PENDING: "PENDING",
  ONGOING: "ONGOING",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};

const initialState = {
  uploadFilesProgress: [],
};

export default (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case UPLOAD_FILES: {
        break;
      }

      case UPLOAD_FILES_REQUESTED: {
        draft.uploadFilesProgress = [];
        action.files.forEach((f) => {
          draft.uploadFilesProgress.push({
            name: f.name,
            progress: 0,
            status: FileUploadStatus.PENDING,
          });
        });
        break;
      }

      case UPDATE_FILE_UPLOAD_PROGRESS: {
        draft.uploadFilesProgress[action.fileIndex].progress = action.progress;
        draft.uploadFilesProgress[action.fileIndex].status =
          FileUploadStatus.ONGOING;
        break;
      }

      case UPLOAD_FILE_SUCCESS: {
        draft.uploadFilesProgress[action.fileIndex].status =
          FileUploadStatus.SUCCESS;
        break;
      }

      case UPLOAD_FILE_ERROR: {
        draft.uploadFilesProgress[action.fileIndex].status =
          FileUploadStatus.ERROR;
        break;
      }

      case UPLOAD_FILES_CLEAR_ALL_PROGRESS: {
        draft.uploadFilesProgress = [];
        break;
      }

      case DELETE_FILE: {
        break;
      }

      case RETRIEVE_FILES: {
        break;
      }

      default: {
        break;
      }
    }
  });

export const uploadFiles = ({ values }, history) => {
  return (dispatch) => {
    const files = _.get(values, "files", []);
    dispatch({
      type: UPLOAD_FILES_REQUESTED,
      files,
    });

    for (let i = 0; i < files.length; i++) {
      const data = new FormData();
      data.append("file", files[i]);
      data.append("auth_token", _.get(values, "auth_token"));
      data.append("group_id", _.get(values, "group_id"));
      data.append("parent_object_id", _.get(values, "parent_object_id"));
      data.append(
        "parent_content_type_app_label",
        _.get(values, "parent_content_type_app_label")
      );
      data.append(
        "parent_content_type_model",
        _.get(values, "parent_content_type_model")
      );
      data.append(
        "view_permission_type",
        _.get(values, "view_permission_type")
      );
      data.append(
        "delete_permission_type",
        _.get(values, "delete_permission_type")
      );

      const config = {
        onUploadProgress: (progress) => {
          const percentage = Math.floor(
            (progress.loaded * 100) / progress.total
          );

          dispatch(
            updateFileUploadProgress({ fileIndex: i, progress: percentage })
          );
        },
      };

      axios
        .post(
          process.env.REACT_APP_API_SERVER_HOST +
            process.env.REACT_APP_API_LIB_FILE_UPLOAD_FILE,
          data,
          config
        )
        .then((response) => {
          dispatch(uploadFileSuccess(i));
        })
        .catch((errorResponse) => {
          dispatch(uploadFileError(i));
        });
    }
  };
};

export const updateFileUploadProgress = ({ fileIndex, progress }) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_FILE_UPLOAD_PROGRESS, fileIndex, progress });
  };
};

export const uploadFileSuccess = (fileIndex) => {
  return (dispatch) => {
    dispatch({ type: UPLOAD_FILE_SUCCESS, fileIndex });
  };
};

export const uploadFileError = (fileIndex) => {
  return (dispatch) => {
    dispatch({ type: UPLOAD_FILE_ERROR, fileIndex });
  };
};

export const uploadFilesClearAllProgress = () => {
  return (dispatch) => {
    dispatch({ type: UPLOAD_FILES_CLEAR_ALL_PROGRESS });
  };
};

export const deleteFile = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "file.deleteFile",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LIB_FILE_DELETE_FILE,
        values
      )
      .then((response) => {
        dispatch({ type: DELETE_FILE });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "file.deleteFile",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = DELETE_FILE_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "file.deleteFile",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

export const retrieveFiles = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "file.retrieveFiles",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LIB_FILE_RETRIEVE_FILES,
        values
      )
      .then((response) => {
        dispatch({ type: RETRIEVE_FILES });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? { context: "file.retrieveFiles" },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = RETRIEVE_FILES_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "file.retrieveFiles",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};
